<span class="flex items-center justify-center" [class]="box()">
  @if (dimensions()) {
    <span
      class="h-full rounded-[3px] border-[1.5px] transition-colors"
      [class]="active() ? 'border-[#0A84FF] bg-blue-50' : 'border-gray-400 bg-gray-50'"
      [style.width.%]="widthPercent() * 0.9"
    ></span>
  } @else {
    <!-- "All sizes": two stacked outlines -->
    <span class="relative h-full w-[70%]">
      <span class="absolute inset-0 translate-x-[18%] -translate-y-[6%] scale-90 rounded-[3px] border-[1.5px] border-gray-300 bg-white"></span>
      <span
        class="absolute inset-0 rounded-[3px] border-[1.5px] bg-white"
        [class]="active() ? 'border-[#0A84FF]' : 'border-gray-400'"
      ></span>
    </span>
  }
</span>
